import {
    Component,
    ViewChild,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
    ChangeDetectorRef,
    OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';

import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import { MatSort, SortDirection } from '@angular/material/sort';
import { MatLegacyInput as MatInput } from '@angular/material/legacy-input';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { Subscription } from 'rxjs';
import {
    AdminUserData,
    GetPermissionsResponseUser,
    GetUsersResponse,
    User,
} from 'app/shared/models/users-permission';
import { UsersService, USER_ROLES, ACTIVE_INACTIVE } from 'app/pages/admin/users.service';
import { BehaviorSubject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { StatusCodeService } from 'app/shared/services/status-code.service';
import { UiUtilsService } from 'app/shared/utils/ui-utils.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationButton, ConfirmationDialogComponent } from 'app/shared/components/confirmation-dialog/confirmation-dialog.component';
import {
    Active,
    activeInactiveLocationQueryParam,
    All,
    AppQueryParams,
    Customer,
    customerFilter,
    customerLocationGroupQueryParam,
    customerQueryParam,
    InActive,
    sortDirectionParam,
    sortValueParam,
    userSearchPageIndexParam,
    userSearchPageSizeParam,
    userSearchParam,
} from 'app/shared/models/customer';
import { IAdminDetails, IFeatures, USERS_FIRSTNAME_COLUMN, USERS_NAME_COLUMN, UsersDataDisplay } from 'app/shared/models/users';
import { SharedService } from 'app/shared/services/shared.service';
import { SelectOptionType } from 'app/shared/models/add-edit-location';
import { LocationGroupService } from 'app/shared/services/location-group.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { IRoles } from '../../../shared/models/users';
import { TrackBy } from 'app/shared/utils/track-by';
import { IComponentDialog, IComponentDialogConfirmationResult } from 'app/shared/models/component-confirmation';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';


@Component({
    selector: 'app-admin-users',
    templateUrl: './admin-users.component.html',
    styleUrls: ['./admin-users.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AdminUsersComponent implements OnInit, OnDestroy {
    public searchString = new FormControl();
    public customers = new Array<Customer>();
    public isFeatureFilterSelected: boolean;
    public users = new Array<User>();
    public activeInactiveList: SelectOptionType[];
    public usersSummary = new Array<User>();
    public assignedFeatureUsers = new Array<string>();
    public rolesSelected = new Array<string>();
    public filteredData = new Array<User>();
    public showUserSearch: boolean;
    public initialUsersData = new Array<User>();
    private subscriptions = new Array<Subscription>();
    public featureList = new Array<IFeatures>;
    public loggedInUserFeatures:  Array<IFeatures>;
    public isActive: string;
    public allAdminFeatures: Array<IFeatures>;
    public availableFeatures: Array<IFeatures>;
    public userDataChange: BehaviorSubject<UsersDataDisplay[]> = new BehaviorSubject<UsersDataDisplay[]>([]);
    public userDataSource: MatTableDataSource<UsersDataDisplay> | null;
    public userName: string;
    public inActivationHeader: string;
    public inActivationMessage: string;
    public eventValue: string;
    public confirmText: string;
    public cancelText: string;
    public isUserStatusChanged: boolean;
    public isMatTableVisible = true;
    public isUser: boolean;
    public dismissBtnText: string;
    public snackbarErrMsg: string;
    public snackbarSuccessMsg: string;
    public USER_ROLES = USER_ROLES;
    public get userData(): UsersDataDisplay[] {
        return this.userDataChange.value;
    }
    public totalPaginationLength: number;
    @ViewChild(MatPaginator, { static: true }) public userPaginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) public userSort: MatSort;
    @ViewChild(MatInput, { static: true }) public searchBox: MatInput;
    public userFilterColumns = ['userName', 'userEmail', USERS_NAME_COLUMN, 'role', 'customers', 'features', 'active', 'editUser'];
    public userEdited: string;
    public isFetchingUser = false;
    public searchValue: string;
    public pageSize: number;
    public pageIndex: number;

    /**
     * This is track register user permission
     */
    public isRegisterUser: boolean;

    /**
     * Indicates the loading state of the component.
     */
    public isLoading: boolean;
    public loggedInUserRole: string;
    public addNewUserVisible: boolean;
    public roles: Array<IRoles> = [];
    public translateKeys: Array<string> = [
        'COMMON.DISMISS_TEXT',
        'ADMIN.CUSTOMER_ACTIVATED_INACTIVATED_SUCCESS_MESSAGE',
        'ADMIN.CUSTOMER_ACTIVATED_INACTIVATED_ERROR_MESSAGE',
        'ADMIN.ADMIN_USERS.USER_CONFIRM_INACTIVATION_TEXT',
        'ADMIN.ADMIN_USERS.USER_INACTIVATION_MESSAGE',
        'ADMIN.CONFIRM',
        'ADMIN.CANCEL',
    ];

    public isIdexAccount?: boolean;

    /** #45604 Get users subscription, as attribute to be able to cancel it */
    private allUsersSubscription: Subscription;

    public data: AdminUserData;
    public customerForUser: Customer[];

    public trackById = TrackBy.byId;
    public trackByValue = TrackBy.byValue();
    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private locationGroupService: LocationGroupService,
        private usersService: UsersService,
        private sharedService: SharedService,
        private translate: TranslateService,
        private statusCodeService: StatusCodeService,
        private uiUtilsService: UiUtilsService,
        private matDialog: MatDialog,
        private snackBar: MatSnackBar,
    ) {
        /*  Search by user email address changes  */
        this.searchString.valueChanges
            .pipe(debounceTime(400))
            .pipe(distinctUntilChanged())
            .subscribe(
                (res: string) => {
                    this.filterUsers(res);
                },
                (error) => {},
            );

        translate.get(this.translateKeys).subscribe((translateValues) => {
            this.dismissBtnText = translateValues['COMMON.DISMISS_TEXT'];
            this.snackbarErrMsg = translateValues['ADMIN.CUSTOMER_ACTIVATED_INACTIVATED_ERROR_MESSAGE'];
            this.inActivationHeader = translateValues['ADMIN.ADMIN_USERS.USER_CONFIRM_INACTIVATION_TEXT'];
            this.inActivationMessage = translateValues['ADMIN.ADMIN_USERS.USER_INACTIVATION_MESSAGE'];
            this.confirmText = translateValues['ADMIN.CONFIRM'];
            this.cancelText = translateValues['ADMIN.CANCEL'];
            this.snackbarSuccessMsg = translateValues['ADMIN.CUSTOMER_ACTIVATED_INACTIVATED_SUCCESS_MESSAGE'];
        });
    }

    public ngOnInit() {
        // check permission for register user
        this.subscriptions.push(
            this.usersService.isRegisterUserFeatureAllowed.subscribe(
                (response) => {
                    this.isRegisterUser = response;
                },
                (ignoreError) => {},
            ),
        );

        this.loggedInUserRole = USER_ROLES.NONE;
        this.addNewUserVisible = false;

        this.statusCodeService.userInfo.subscribe(
            (res) => {
                this.loggedInUserRole = res && res.userRole ? res.userRole[0] : USER_ROLES.NONE;
                this.isIdexAccount = res.isIdex;
                this.addNewUserVisible =
                    this.loggedInUserRole === USER_ROLES.ADMIN ||
                    ((this.loggedInUserRole === USER_ROLES.CUSTOMER_ADMIN ||
                    this.loggedInUserRole === USER_ROLES.CUSTOMER_USER_MANAGER) && this.isRegisterUser);
                    // #22179 have to rollback - all Customer Admins can create new users !
                    // (this.loggedInUserRole === USER_ROLES.CUSTOMER_ADMIN && this.isRegisterUser && this.isIdexAccount);

                    this.usersService.getAllRoles().subscribe((roles: Array<IRoles>) => {
                        this.roles = roles;

                        if(this.loggedInUserRole === USER_ROLES.CUSTOMER_ADMIN) {
                            this.roles = this.roles.filter(r => r.name !== USER_ROLES.ADMIN);
                        }

                        this.uiUtilsService.safeChangeDetection(this.cdr);
                    });
            },
            (ignoreError) => {},
        );

        this.usersService.getAllFeatures().subscribe((features: Array<IFeatures>) => {
            this.loggedInUserFeatures = features.filter((x) => !x.canassigncustomer);
            this.uiUtilsService.safeChangeDetection(this.cdr);

        });

        this.isLoading = true;
        // subscribe to route change
        this.searchValue = this.searchString.value;
        this.pageSize = this.userPaginator.pageSize;
        this.pageIndex = this.userPaginator.pageIndex;

        this.activeInactiveList = [
            { value: '1', text: 'All' },
            { value: '2', text: 'Active' },
            { value: '3', text: 'Inactive' },
        ];

        // disable location group selector in top-nav
        this.locationGroupService.locationGroupDisabledStatus = true;

        this.statusCodeService.userEmailInEditScreen.subscribe(
            (editedUser: string) => {
                this.userEdited = editedUser;
            }
        );
        //  get all the users
        if (!!this.searchValue) {
            this.searchString.setValue(this.searchValue);
        }

        this.activatedRoute.queryParamMap.subscribe(
            (params: ParamMap) => {
                this.searchValue = params.get(userSearchParam);
                this.pageIndex = Number(params.get(userSearchPageIndexParam));
                this.pageSize = Number(params.get(userSearchPageSizeParam));
                if(params.has(sortValueParam)) {
                    this.userSort.active = params.get(sortValueParam);
                    this.userSort.direction = params.get(sortDirectionParam) as SortDirection;
                }

                if(params.has(userSearchPageIndexParam)) {
                    this.userPaginator.pageIndex = this.pageIndex;
                }

                if(params.has(userSearchPageSizeParam)) {
                    this.userPaginator.pageSize = this.pageSize;
                }

                if(params.has(userSearchParam)) {
                    this.searchString.setValue(this.searchValue, {emitEvent: false});
                }


                this.getUsers(this.pageSize, this.pageIndex, this.searchValue);
            }
        );
    }

    public filterCustomers() {
        this.filteredData = this.usersSummary;

        this.filteredData =
            this.eventValue === ACTIVE_INACTIVE.ACTIVE || this.eventValue === ACTIVE_INACTIVE.INACTIVE
                ? this.filteredData.filter((user) => user.isActive === (this.eventValue === ACTIVE_INACTIVE.ACTIVE))
                : this.usersSummary;
        if (this.assignedFeatureUsers && this.assignedFeatureUsers.length > 0) {
            this.filteredData = this.filteredData.filter(
                (x) =>
                    x.features &&
                    x.features.length > 0 &&
                    x.features.some((z) => this.assignedFeatureUsers.some((y) => z.trim() === y.trim())),
            );
        }
        this.isMatTableVisible = this.filteredData.length > 0;
        this.totalPaginationLength = this.filteredData.length;
        this.users = this.filteredData;
        this.generateUserTable();
    }

    public getUserByFeatures(eventValue: string[]) {
        this.assignedFeatureUsers = [];
        this.isFeatureFilterSelected = eventValue.length > 0;
        if (this.isFeatureFilterSelected) {
            this.assignedFeatureUsers.push(...eventValue);
        }
        this.getUsers(this.pageSize, this.pageIndex, this.searchString.value);
    }


    public onRoleSelection(eventValue: string[]) {
        this.rolesSelected = [];
        if(eventValue.length > 0){
            this.rolesSelected.push(...eventValue);
        }
        this.getUsers(this.pageSize, this.pageIndex, this.searchString.value);
    }

    public onSelection(eventValue: string) {
        if (eventValue === Active) {
            this.isActive = customerFilter.Active;
        } else if (eventValue === InActive) {
            this.isActive = customerFilter.Inactive;
        } else if (eventValue === All) {
            this.isActive = customerFilter.All;
        }
        this.getUsers(this.pageSize, this.pageIndex, this.searchString.value);
    }

    public showUsersFilters(value?: boolean) {
        if (value == null) {
            this.showUserSearch = !this.showUserSearch;
            if (this.showUserSearch === false) {
                this.filterCustomers();
                this.assignedFeatureUsers = [];
                this.rolesSelected = [];
            }
            return;
        }
        this.showUserSearch = value;
    }

    /**
     * Method takes a sting as an argument and filters out users whose email addresses include the string
     * @param searchString - string to search for in email addresses
     */
    public filterUsers(searchString: string) {
        const pageSize: number = this.userPaginator.pageSize;
        this.pageIndex = 0;
        this.getUsers(pageSize, this.pageIndex, searchString);
    }
    /**
     * Method generates a table of users
     */
    public generateUserTable() {
        this.userDataSource = null;
        this.userDataChange = new BehaviorSubject<UsersDataDisplay[]>([]);
        this.users.forEach((user) => {
            // Flag to show the edited row
            const highlightEditedRow: boolean = this.userEdited !== '' && this.userEdited === user.userEmail;
            const userCopiedData = this.userData.slice();
            const data = {
                userID: user.userID,
                firstName: user.firstName,
                lastName: user.lastName,
                userEmail: user.userEmail,
                userName: user.userName,
                name: [user.firstName, user.lastName].join(' '),
                role: user.role,
                locations: user.locations,
                customers: user.customers,
                features: user.features.sort(),
                isSelected: user.isSelected,
                highLight: highlightEditedRow,
                disable: this.loggedInUserRole === USER_ROLES.CUSTOMER_ADMIN && user.role === USER_ROLES.CUSTOMER_ADMIN,
                isActive: user.isActive,
            };
            userCopiedData.push(data);
            this.userDataChange.next(userCopiedData);
        });
        this.userDataSource = new MatTableDataSource(this.userData);
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    public ngOnDestroy() {
        this.statusCodeService.userEmailInEditScreen.next('');

        // re-enable location group selector in top-nav
        this.locationGroupService.locationGroupDisabledStatus = false;

        this.subscriptions.forEach((subscription) => subscription.unsubscribe());

        this.statusCodeService.userEmailInEditScreen.next('');
    }

    public activateUser(user: User) {
        this.userName = user.userName;
        this.uiUtilsService.safeChangeDetection(this.cdr);
        if (user.isActive) {
            this.matDialog
                .open<ConfirmationDialogComponent, IComponentDialog, IComponentDialogConfirmationResult>(ConfirmationDialogComponent, {
                    disableClose: true,
                    data: {
                        title: this.inActivationHeader,
                        message: this.inActivationMessage,
                        okText: this.confirmText,
                        cancelText: this.cancelText,
                    },
                })
                .afterClosed()
                .subscribe((result) => {
                    if (result.whichButtonWasPressed === ConfirmationButton.ok) {
                        this.isLoading = true;
                        this.changeState(user.userID, false);
                    } else {
                        this.generateUserTable();
                    }
                });
        } else {
            this.isLoading = true;
            this.changeState(user.userID, true);
        }
    }
    public changeState(userID: string, status: boolean) {
        this.usersService.activateStatus(userID, status).subscribe(
            () => {
                this.isUserStatusChanged = true;
                this.isUser = true;
                this.getUsers(this.pageSize, this.pageIndex, this.searchString.value);
                this.isLoading = false;
                this.uiUtilsService.safeChangeDetection(this.cdr);
            },
            () => {
                // snak bar message when error occured
                this.snackBar.open(this.snackbarErrMsg + ' ' + this.userName, this.dismissBtnText, {
                    panelClass: 'custom-error-snack-bar',
                });
            },
        );
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }

    /**
     * Method brings up a pop up window with user's name and customers menu
     * @param user the user data object.
     */
    public customerAssociation(user: User) {
        this.isLoading = true;
        const customerAssociation = this.usersService.getUserPermissions(user.userID).subscribe(
            (userData: GetPermissionsResponseUser) => {
                const userFullData = this.users.find((x) => x.userID === user.userID);
                userData.userID = userFullData.userID;
                this.selectUser(user);
                this.customerForUser = userData.customers.map((x) => x.customer);
                if (user.userEmail === this.usersService.userName) {
                    const defaultCustomer = this.usersService.defaultCustomer.getValue();
                    userData.customers.forEach(
                        (customer) => {
                            if (defaultCustomer && customer.customer.customerID === defaultCustomer) {
                                customer.defaultCustomer = true;
                            } else {
                                customer.defaultCustomer = false;
                            }
                        }
                    );
                }
                // storing data in an object to send to the detail screen
                this.data = {
                    user: userData,
                    customers: this.customerForUser,
                };
                // setup the route for admin detail screen
                this.setupAdminDetailRoute(userFullData);
            }
        );
        this.subscriptions.push(customerAssociation);
    }
    /**
     * Function to setup the admin detail route
     */
    public setupAdminDetailRoute(userFullData: User) {
        const currentCustomerId = Number(this.activatedRoute.snapshot.queryParamMap.get(customerQueryParam));
        // get current query params for location group
        const locationGroupId = Number(this.activatedRoute.snapshot.queryParamMap.get(customerLocationGroupQueryParam));
        // get current query params for showing all locations
        const isShowAllLocations = Number(
            this.activatedRoute.snapshot.queryParamMap.get(activeInactiveLocationQueryParam),
        );
        if (!userFullData) {
            // Using Behaviour Subjects next method to emit the data
            this.sharedService.adminUserData.next(null);
        } else {
            sessionStorage.setItem('adsGuid', userFullData.userID);
            // Using Behaviour Subjects next method to emit the data
            this.sharedService.adminUserData.next(this.data);
        }
        // get global query params
        const appQueryParams = <AppQueryParams>{
            c: currentCustomerId,
            lg: locationGroupId || undefined,
            lt: isShowAllLocations || undefined,
            u: !userFullData ? 'registeruser' : userFullData.userEmail,
            s: !!this.searchString.value ? this.searchString.value : undefined,
            pi: !this.userPaginator.pageIndex ? 0 : Number(this.userPaginator.pageIndex),
            ps: this.userPaginator.pageSize || undefined,
        };

        if(this.userSort.active) {
            appQueryParams.psa = this.userSort.active;
            appQueryParams.psd = this.userSort.direction;
        }
        // Navigating with required params
        this.isLoading = false;
        this.router.navigate(['/pages/admin/details'], {
            queryParams: appQueryParams,
            relativeTo: this.activatedRoute,
        });
    }

    /**
     * Method takes a user as a parameter and sets this user as selected
     * for the purpose of highlighting
     * @param user
     */
    private selectUser(user: User) {
        this.userData.forEach((listUser) => {
            listUser.isSelected = listUser.userEmail === user.userEmail;
        });
        this.uiUtilsService.safeChangeDetection(this.cdr);
    }
    /**
     * checks if the name length is more than specific length
     */
    public validateLongStringLength(str: string, strLength: number): boolean {
        if ((str + '').length > strLength) {
            return true;
        } else {
            return false;
        }
    }
    /**
     * provide space between two word wih , saperated
     */
    public provideSpace(str: string) {
        str = str + '';
        return str.replace(/,/g, ', ');
    }

    public changePage(page: PageEvent) {
        const searchValue = this.searchString.value;
        this.getUsers(page.pageSize, page.pageIndex, searchValue, true);
    }

    public onDataSort() {
        this.pageIndex = 0;
        this.getUsers(this.pageSize, this.pageIndex, this.searchString.value);
    }

    public getUsers(pageSize: number, pageIndex: number, searchValue: string, isPageChanged = false) {
        // #45604 If we have another request going on, cancel it, since searchText did change
        if (this.isFetchingUser) {
            this.allUsersSubscription?.unsubscribe();
        }

        let sort: {value: string, direction: string} = null;
        if(this.userSort.active) {
            sort = {
                value: this.userSort.active !== USERS_NAME_COLUMN ? this.userSort.active : USERS_FIRSTNAME_COLUMN,
                direction: this.userSort.direction
            };
        }

        //  get all the users
        this.disableSearchBox();
        this.isFetchingUser = true;
        this.isLoading = true;
        this.allUsersSubscription = this.usersService
            .getAllUsers(pageSize, pageIndex + 1, searchValue, null, this.isActive, this.assignedFeatureUsers, this.rolesSelected, sort)
            .subscribe(
                (response: GetUsersResponse) => {
                    if (response && response.payload && response.payload.length > 0) {
                        this.users = this.usersSummary = this.initialUsersData = response.payload;
                        this.users
                            .filter((x) => x.role === USER_ROLES.ADMIN)
                            .map((x) => {
                                (x.customers = 'All'), (x.locations = 'All');
                            });
                        this.totalPaginationLength = Math.round(response.count);
                        this.userPaginator.length = Math.round(response.count);
                        this.isMatTableVisible = this.users.length > 0;
                    } else {
                        this.users = this.initialUsersData = [];
                        this.totalPaginationLength = 0;
                        this.userPaginator.length = 0;
                    }
                    if (this.isUser) {
                        // snack bar message
                        const simpleSnackBarRef = this.snackBar.open(
                            this.userName + ' ' + this.snackbarSuccessMsg,
                            this.dismissBtnText,
                        );
                        setTimeout(simpleSnackBarRef.dismiss.bind(simpleSnackBarRef), 10000);
                    }
                    this.isUser = false;
                    this.generateUserTable();
                    if (!!pageSize) {
                        this.userPaginator.pageSize = pageSize;
                    }
                    // Hiding loader
                    this.isFetchingUser = this.isLoading = false;
                    this.disableSearchBox(false);
                    this.uiUtilsService.safeChangeDetection(this.cdr);

                },
                () => {
                    // error block
                    this.isFetchingUser = this.isLoading = false;
                    this.disableSearchBox(false);
                    this.uiUtilsService.safeChangeDetection(this.cdr);
                },
            );
        this.subscriptions.push(this.allUsersSubscription);
    }

    public disableSearchBox(isDisable = true) {
        if (this.searchBox) {
            this.searchBox.disabled = isDisable;
        }
    }
}
